import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  API_STATUS_REQ_CREATE,
  API_STATUS_REQ_UPDATE,
} from '../../services/api';
import {
  changeAssessorEditingValue,
  clearAssessorEditing,
  loadAssessorByCPF,
  loadProgramasAtivos,
  saveAssessorByCPF,
} from '../../store/modules/AssessoresActions';
import { loadAllEmpresas } from '../../store/modules/EmpresasActions';
import { loadAllCooperativas } from '../../store/modules/LogradouroActions';
import { closeModal } from '../../store/modules/ModalActions';
import { getFormattedCNPJ } from '../../utils/DataFormatUtils';
import {
  getElementID,
  getInputFocusInFocusOutAttr,
} from '../../utils/HTMLUtils';
import { getUnmaskedValue } from '../../utils/InputMaskUtils';
import {
  allIsTrue,
  celularIsValid,
  cpfIsValid,
  doubleNameIsValid,
  emailIsValid,
  EMAIL_MAX_LENGTH,
  maskedValueRequiredIsValid,
  NOME_MAX_LENGTH,
  requiredIsValid,
  NOME_QUALIFICACAO_MAX_LENGTH,
  dateIsValid,
} from '../../utils/ValidationUtils';
import { CustomTextField } from '../CustomTextField';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import {
  CPFMaskedInput,
  DateMaskedInput,
  PhoneMaskedInput,
} from '../MaskedInputs';
import NewAutoCompleteField from '../NewAutoCompleteField/NewAutoCompleteField';
import { Col } from './../Col';
import { CustomButton } from './../CustomButton';
import { Row } from './../Row';
import styles from './AssessorEditModal.scss';
import {
  ASSESSOR_EDIT_DOUTORADO_COMPLETO,
  ASSESSOR_EDIT_DOUTORADO_INCOMPLETO,
  ASSESSOR_EDIT_ENSINO_SUPERIOR_COMPLETO,
  ASSESSOR_EDIT_ENSINO_SUPERIOR_INCOMPLETO,
  ASSESSOR_EDIT_ESPECIALIZACAO_COMPLETA,
  ASSESSOR_EDIT_ESPECIALIZACAO_INCOMPLETA,
  ASSESSOR_EDIT_MESTRADO_COMPLETO,
  ASSESSOR_EDIT_MESTRADO_INCOMPLETO,
} from 'library/AssessorEditCampoFormacaoAcademica';
import { GenericModalCadastro } from 'components/GenericModal/GenericModalCadastro';
import { NewAutoCompleteFieldEmpresas } from 'components/NewAutoCompleteField/NewAutoCompleteFieldEmpresas';

const rootElementId = 'assessor-edit-modal';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  open: false,
  saving: false,
  loading: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,

  nomeChanged: false,
  celularChanged: false,
  emailChanged: false,
  // maeChanged: false,
  dataNascimentoChanged: false,
  // rgChanged: false,
  cpfChanged: false,
  cooperativasChanged: false,
  idEmpresaChanged: false,
  idFormacaoAcademicaChanged: false,
  idProgramasEducacionaisChanged: false,
  focusedFieldName: null,
};

class AssessorEditModal extends Component {
  validations = {
    nomeIsValid: { status: false },
    celularIsValid: { status: false },
    emailIsValid: { status: false },
    // maeIsValid: { status: false },
    dataNascimentoIsValid: { status: false },
    // rgIsValid: { status: false },
    cpfIsValid: { status: false },
    cooperativaIsValid: { status: false },
    loadingCoopIsValid: { status: false },
    programasIsValid: { status: false },
  };

  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
    this.allFormacaoAcademica = [
      {
        id: ASSESSOR_EDIT_ENSINO_SUPERIOR_INCOMPLETO,
        name: this.props.languageValues
          .cadastroAssessorEnsinoSuperiorIncompleto,
      },
      {
        id: ASSESSOR_EDIT_ENSINO_SUPERIOR_COMPLETO,
        name: this.props.languageValues.cadastroAssessorEnsinoSuperiorCompleto,
      },
      {
        id: ASSESSOR_EDIT_ESPECIALIZACAO_INCOMPLETA,
        name: this.props.languageValues
          .cadastroAssessorEspecializacaoIncompleta,
      },
      {
        id: ASSESSOR_EDIT_ESPECIALIZACAO_COMPLETA,
        name: this.props.languageValues.cadastroAssessorEspecializacaoCompleta,
      },
      {
        id: ASSESSOR_EDIT_MESTRADO_INCOMPLETO,
        name: this.props.languageValues.cadastroAssessorMestradoIncompleto,
      },
      {
        id: ASSESSOR_EDIT_MESTRADO_COMPLETO,
        name: this.props.languageValues.cadastroAssessorMestradoCompleto,
      },
      {
        id: ASSESSOR_EDIT_DOUTORADO_INCOMPLETO,
        name: this.props.languageValues.cadastroAssessorDoutoradoIncompleto,
      },
      {
        id: ASSESSOR_EDIT_DOUTORADO_COMPLETO,
        name: this.props.languageValues.cadastroAssessorDoutoradoCompleto,
      },
    ];

    this.allFormacaoAcademicaOptions = this.allFormacaoAcademica.map(
      (item) => ({
        label: item.name,
        value: item.id,
      })
    );

    this.props.loadAllCooperativas();
    this.props.loadAllEmpresas();
    this.setValue = this.setValue.bind(this);
    this.focusIn = this.focusIn.bind(this);
    this.focusOut = this.focusOut.bind(this);
  }

  changeState(newState) {
    this.setState({
      ...this.state,
      ...newState,
    });
  }

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  reset() {
    this.setState(INITIAL_STATE);
    this.props.clearAssessorEditing();
  }

  componentDidMount() {
    this.props.loadProgramasAtivos();
  }

  componentWillUnmount() {
    this.reset();
  }

  UNSAFE_componentWillMount() {
    if (this.editing()) {
      this.loadAssessor();
    }
  }

  loadAssessor() {
    this.changeState({
      open: true,
      loading: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });
    this.props.loadAssessorByCPF(
      this.props.cpf,
      () => {
        this.formIsValid(true);
        this.changeState({
          loading: false,
          nomeChanged: true,
          emailChanged: true,
          // maeChanged: true,
          dataNascimentoChanged: true,
          // rgChanged: true,
          cpfChanged: true,
          cooperativasChanged: true,
          idFormacaoAcademicaChanged: true,
          idEmpresaChanged: true,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadAssessorEditing,
          options: {
            variant: 'error',
          },
        });
        this.toClose();
      }
    );
  }

  getTitle() {
    if (this.editing()) {
      return this.props.languageValues.editAssessorModalTitle;
    }
    return this.props.languageValues.newAssessorModalTitle;
  }

  getSubmitLabel() {
    if (this.editing()) {
      return this.props.languageValues.salvar;
    }
    return this.props.languageValues.cadastrar;
  }

  setValue(event) {
    this.setState({
      ...this.state,
      [event.target.name + 'Changed']: true,
    });
    if (event.target.name === 'formacaoAcademica') {
      this.setState({ idFormacaoAcademicaChanged: true });
    }
    return this.props.changeAssessorEditingValue(
      event.target.name,
      event.target.value
    );
  }

  simpleValidation(value) {
    return value && value.length > 0 ? true : false;
  }

  nomeIsValid(force) {
    if (force || this.state.focusedFieldName === 'nome') {
      const value = this.props.assessores.assessorEditing.nome;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.nome.required
      );
      const validation = doubleNameIsValid(
        value,
        this.props.languageValues.validations.nome.validation
      );
      if (!required.status) {
        this.validations.nomeIsValid = required;
        return required;
      }
      if (!validation.status) {
        this.validations.nomeIsValid = validation;
        return validation;
      }
      this.validations.nomeIsValid = {
        status: true,
      };
      return this.validations.nomeIsValid;
    } else {
      return this.validations.nomeIsValid;
    }
  }

  programasIsValid() {
    const programasEducacionais =
      this.props.assessores.assessorEditing.programasEducacionais;
    return programasEducacionais && programasEducacionais.length > 0
      ? { status: true }
      : {
        status: false,
        error:
          this.props.languageValues.validations.idProgramasEducacionais
            .required,
      };
  }

  celularValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'celular') {
      const value = this.props.assessores.assessorEditing.celular;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.celular.required
      );
      const length = celularIsValid(
        value,
        this.props.languageValues.validations.celular.length
      );
      if (!required.status) {
        this.validations.celularIsValid = required;
        return this.validations.celularIsValid;
      }
      if (!length.status) {
        this.validations.celularIsValid = length;
        return this.validations.celularIsValid;
      }
      this.validations.celularIsValid = {
        status: true,
      };
      return this.validations.celularIsValid;
    } else {
      return this.validations.celularIsValid;
    }
  }

  dataNascimentoIsValid(force) {
    if (force || this.state.focusedFieldName === 'dataNascimento') {
      const value = this.props.assessores.assessorEditing.dataNascimento;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.birthDate.required
      );
      const validation = dateIsValid(
        value,
        this.props.languageValues.validations.birthDate.validation
      );
      if (!required.status) {
        this.validations.dataNascimentoIsValid = required;
        return this.validations.dataNascimentoIsValid;
      }
      if (!validation.status) {
        this.validations.dataNascimentoIsValid = validation;
        return this.validations.dataNascimentoIsValid;
      }
      this.validations.dataNascimentoIsValid = {
        status: true,
      };
      return this.validations.dataNascimentoIsValid;
    } else {
      return this.validations.dataNascimentoIsValid;
    }
  }

  emailValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'email') {
      const value = this.props.assessores.assessorEditing.email;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.email.required
      );
      const validation = emailIsValid(
        value,
        this.props.languageValues.validations.email.validation
      );
      if (!required.status) {
        this.validations.emailIsValid = required;
        return this.validations.emailIsValid;
      }
      if (!validation.status) {
        this.validations.emailIsValid = validation;
        return this.validations.emailIsValid;
      }
      this.validations.emailIsValid = {
        status: true,
      };
      return this.validations.emailIsValid;
    } else {
      return this.validations.emailIsValid;
    }
  }

  cpfValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'cpf') {
      const value = this.props.assessores.assessorEditing.cpf;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.cpf.required
      );
      const validation = cpfIsValid(
        value,
        this.props.languageValues.validations.cpf.validation
      );
      if (!required.status) {
        this.validations.cpfIsValid = required;
        return this.validations.cpfIsValid;
      }
      if (!validation.status) {
        this.validations.cpfIsValid = validation;
        return this.validations.cpfIsValid;
      }
      this.validations.cpfIsValid = {
        status: true,
      };
      return this.validations.cpfIsValid;
    } else {
      return this.validations.cpfIsValid;
    }
  }

  cooperativaIsValid() {
    return this.props.assessores.assessorEditing.cooperativas.length > 0
      ? {
        status: true,
      }
      : {
        status: false,
        error: this.props.languageValues.validations.cooperativas.required,
      };
  }

  idFormacaoAcademicaIsValid() {
    const formacaoAcademica =
      this.props.assessores.assessorEditing.formacaoAcademica;
    if (formacaoAcademica >= 0) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
        error:
          this.props.languageValues.validations.idFormacaoAcademicas.required,
      };
    }
  }

  processing() {
    return this.state.sending || this.state.loading ? true : false;
  }

  formIsValid(force) {
    const arr = [
      this.nomeIsValid(force).status,
      this.celularValueIsValid(force).status,
      this.dataNascimentoIsValid(force).status,
      this.emailValueIsValid(force).status,
      // this.maeIsValid(force).status,
      // this.rgIsValid(force).status,
      this.editing() ? true : this.cpfValueIsValid(force).status,
      this.cooperativaIsValid().status,
      this.programasIsValid().status,
      this.idFormacaoAcademicaIsValid().status,
    ];
    return allIsTrue(arr);
  }

  editing() {
    return this.props.cpf ? true : false;
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return false;
    }

    this.changeState({
      saving: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });

    this.props.saveAssessorByCPF(
      {
        celular: getUnmaskedValue(
          this.props.assessores.assessorEditing.celular
        ),
        cpf: getUnmaskedValue(this.props.assessores.assessorEditing.cpf),
        dataNascimento: getUnmaskedValue(
          this.props.assessores.assessorEditing.dataNascimento
        ),
        email: this.props.assessores.assessorEditing.email.trim(),
        cooperativas: this.props.assessores.assessorEditing.cooperativas,
        programasEducacionais:
          this.props.assessores.assessorEditing.programasEducacionais,
        formacaoAcademica:
          this.props.assessores.assessorEditing.formacaoAcademica,
        qualificacao: this.props.assessores.assessorEditing.qualificacao,
        cooperativasGestor:
          this.props.assessores.assessorEditing.cooperativasGestor,
        idEmpresa:
          this.props.assessores.assessorEditing.idEmpresa &&
            this.props.assessores.assessorEditing.idEmpresa > -1
            ? this.props.assessores.assessorEditing.idEmpresa
            : null,
        // mae: this.props.assessores.assessorEditing.mae.trim(),
        nome: this.props.assessores.assessorEditing.nome.trim(),
        // rg: this.props.assessores.assessorEditing.rg.trim(),
        statusReq: this.editing()
          ? API_STATUS_REQ_UPDATE
          : API_STATUS_REQ_CREATE,
      },
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.editing()
            ? this.props.languageValues.successSalvarAssessor
            : this.props.languageValues.successCadastrarAssessor,
          options: {
            variant: 'success',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
        this.toClose();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message: error.response.statusText
            ? error.response.statusText
            : this.editing()
              ? this.props.languageValues.erroSalvarAssessor
              : this.props.languageValues.erroCadastrarAssessor,
          options: {
            variant: 'error',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      }
    );
  }

  toClose() {
    this.props.closeModal(this.props.modalKey);
  }

  focusIn(fieldName) {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  }

  focusOut(fieldName) {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  }

  allowEdit() {
    return this.props.auth.userPermissions.assessores.edit;
  }

  atualizarCooperativasGestor = () => {
    const cooperativas = this.props.assessores.assessorEditing.cooperativas;
    const cooperativasGestor =
      this.props.assessores.assessorEditing.cooperativasGestor;
    const cooperativasGestorForaDeCooperativas = cooperativasGestor.filter(
      (item) => {
        return cooperativas.indexOf(item) === -1;
      }
    );
    if (cooperativasGestorForaDeCooperativas.length > 0) {
      this.setValue({
        target: {
          name: 'cooperativasGestor',
          value: cooperativasGestor.filter((item) => {
            return cooperativas.indexOf(item) > -1;
          }),
        },
      });
    }
  };

  getCooperativasGestor = () => {
    return this.props.logradouro.allCooperativas
      .filter((item) => {
        return (
          this.props.assessores.assessorEditing.cooperativas.indexOf(
            item.codigo
          ) > -1
        );
      })
      .map((item) => {
        return {
          label: item.nome,
          value: item.codigo,
        };
      });
  };

  fieldQualificacaoDisabled() {
    const { formacaoAcademica } = this.props.assessores.assessorEditing;
    if (formacaoAcademica === -1 || formacaoAcademica === undefined) {
      this.props.assessores.assessorEditing.qualificacao = '';
      return true;
    }
    return false;
  }

  render() {
    const { programas } = this.props;
    return (
      <GenericModalCadastro
        id={rootElementId}
        onClose={() => {
          this.toClose();
        }}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={
          <>
            {this.getTitle()}
            {this.state.loading || this.state.saving ? (
              <RefreshIcon className={rootClassName + '-loading-icon'} />
            ) : null}
          </>
        }
        footerContent={
          <>
            <Row>
              <Col cols={[12, 6, 6, 6, 6]} className='col-legend'>
                <div className='legend'>
                  {this.props.languageValues.campoObrigatorio}
                </div>
              </Col>
            </Row>
            <Row>
              <Col cols={[12, 12, 6, 6, 5]}>
                <CustomButton
                  id={getElementID(rootElementId, 'cancel')}
                  theme='pufvYellow'
                  className={rootClassName + '-cancel-button'}
                  label={this.props.languageValues.cancelButton}
                  onClick={() => this.toClose()}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 4]}>
                <CustomButton
                  id={getElementID(rootElementId, 'save')}
                  theme='pufvYellow'
                  className={rootClassName + '-save-buttom'}
                  label={this.getSubmitLabel()}
                  disabled={
                    this.state.loading ||
                    this.state.saving ||
                    !this.formIsValid()
                  }
                  rightIcon={<SaveIcon />}
                  type='submit'
                />
              </Col>
            </Row>
          </>
        }
        onSubmit={(event) => {
          event.preventDefault();
          this.toSubmit();
        }}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'nome')}
              label={this.props.languageValues.cadastroAssessorNome}
              name='nome'
              value={this.props.assessores.assessorEditing.nome || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={NOME_MAX_LENGTH}
              helperText={
                this.state.nomeChanged && !this.nomeIsValid().status
                  ? this.nomeIsValid().error
                  : ''
              }
              error={this.state.nomeChanged && !this.nomeIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'email')}
              label={this.props.languageValues.cadastroAssessorEmail}
              name='email'
              value={this.props.assessores.assessorEditing.email || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={EMAIL_MAX_LENGTH}
              helperText={
                this.state.emailChanged && !this.emailValueIsValid().status
                  ? this.emailValueIsValid().error
                  : ''
              }
              error={
                this.state.emailChanged && !this.emailValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'data-nascimento')}
              label={this.props.languageValues.cadastroAssessorDataNascimento}
              name='dataNascimento'
              value={this.props.assessores.assessorEditing.dataNascimento || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.dataNascimentoChanged &&
                  !this.dataNascimentoIsValid().status
                  ? this.dataNascimentoIsValid().error
                  : ''
              }
              error={
                this.state.dataNascimentoChanged &&
                !this.dataNascimentoIsValid().status
              }
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: DateMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'celular')}
              label={this.props.languageValues.cadastroAssessorCelular}
              name='celular'
              value={this.props.assessores.assessorEditing.celular || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                this.state.celularChanged && !this.celularValueIsValid().status
                  ? this.celularValueIsValid().error
                  : ''
              }
              error={
                this.state.celularChanged && !this.celularValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              InputProps={{
                inputComponent: PhoneMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'cpf')}
              label={this.props.languageValues.cadastroAssessorCPF}
              name='cpf'
              value={this.props.assessores.assessorEditing.cpf || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                !this.editing() &&
                  this.state.cpfChanged &&
                  !this.cpfValueIsValid().status
                  ? this.cpfValueIsValid().error
                  : ''
              }
              error={
                !this.editing() &&
                this.state.cpfChanged &&
                !this.cpfValueIsValid().status
              }
              disabled={this.editing() || this.fieldDisabled()}
              InputProps={{
                inputComponent: CPFMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'programasEducacionais')}
                label={this.props.languageValues.cadastroAssessorProgramas}
                options={
                  programas
                    ? programas.map((programa) => ({
                      label: programa.nomePrograma,
                      value: programa.tipoPrograma,
                    }))
                    : []
                }
                value={
                  this.props.assessores.assessorEditing.programasEducacionais
                }
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'programasEducacionais',
                      value: currValue,
                    },
                  });
                }}
                multiple
                loading={this.props.empresas.loadingAllList}
                loadingMessage={this.props.languageValues.loadingProgramas}
                error={
                  this.state.cooperativasChanged &&
                  !this.programasIsValid().status
                }
                helperText={
                  this.state.cooperativasChanged &&
                    !this.programasIsValid().status
                    ? this.programasIsValid().error
                    : ''
                }
                disabled={
                  this.fieldDisabled() || this.props.empresas.loadingAllList
                }
              />
            </Col>
          </Row>
        ) : null}
        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'cooperativas')}
                label={this.props.languageValues.cadastroAssessorCooperativa}
                placeholder={
                  this.props.logradouro.loadingAllCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.props.logradouro.allCooperativas.map((item) => {
                  return {
                    label: item.nome,
                    value: item.codigo,
                  };
                })}
                value={this.props.assessores.assessorEditing.cooperativas}
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cooperativas',
                      value: currValue,
                    },
                  }).then(this.atualizarCooperativasGestor);
                }}
                multiple
                loading={this.props.logradouro.loadingAllCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                error={
                  this.state.cooperativasChanged &&
                  !this.cooperativaIsValid().status
                }
                helperText={
                  this.state.cooperativasChanged &&
                    !this.cooperativaIsValid().status
                    ? this.cooperativaIsValid().error
                    : ''
                }
                disabled={
                  this.fieldDisabled() ||
                  this.props.logradouro.loadingAllCooperativas
                }
              />
            </Col>
          </Row>
        ) : null}

        {this.allowEdit() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'cooperativas-gestor')}
                label={
                  this.props.languageValues.cadastroAssessorCooperativaGestor
                }
                placeholder={
                  this.props.logradouro.loadingAllCooperativas
                    ? this.props.languageValues.loadingCooperativas
                    : ''
                }
                options={this.getCooperativasGestor()}
                value={
                  this.props.assessores.assessorEditing.cooperativasGestor || []
                }
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue({
                    target: {
                      name: 'cooperativasGestor',
                      value: currValue,
                    },
                  });
                }}
                multiple
                loading={this.props.logradouro.loadingAllCooperativas}
                loadingMessage={this.props.languageValues.loadingCooperativas}
                disabled={
                  this.fieldDisabled() ||
                  this.props.logradouro.loadingAllCooperativas
                }
              />
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={getElementID(rootElementId, 'formacaoAcademica')}
              label={
                this.props.languageValues.cadastroAssessorFormacaoAcademica
              }
              options={this.allFormacaoAcademicaOptions}
              value={this.props.assessores.assessorEditing.formacaoAcademica}
              onChange={(value) => {
                const currValue = value ? value.value : -1;
                this.setValue({
                  target: {
                    name: 'formacaoAcademica',
                    value: currValue,
                  },
                });
              }}
              loading={this.props.empresas.loadingAllList}
              loadingMessage={this.props.languageValues.loadingFormacoes}
              error={
                this.state.idFormacaoAcademicaChanged &&
                !this.idFormacaoAcademicaIsValid().status
              }
              helperText={
                this.state.idFormacaoAcademicaChanged &&
                  !this.idFormacaoAcademicaIsValid().status
                  ? this.idFormacaoAcademicaIsValid().error
                  : ''
              }
              disabled={
                this.fieldDisabled() || this.props.empresas.loadingAllList
              }
            />
          </Col>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'qualificacao')}
              placeholder={
                this.props.languageValues
                  .cadastroAssessorQualificacaoPlaceholder
              }
              label={this.props.languageValues.cadastroAssessorQualificacao}
              name='qualificacao'
              value={this.props.assessores.assessorEditing.qualificacao || ''}
              onChange={(event) => {
                this.setValue(event);
              }}
              loading={this.props.empresas.loadingAllList}
              counter={true}
              maxSize={NOME_QUALIFICACAO_MAX_LENGTH}
              disabled={
                this.fieldDisabled() ||
                this.props.empresas.loadingAllList ||
                this.fieldQualificacaoDisabled()
              }
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteFieldEmpresas
              id={getElementID(rootElementId, 'idEmpresa')}
              label={this.props.languageValues.cadastroAssessorEmpresa}
              placeholder={
                this.props.empresas.loadingAllList
                  ? this.props.languageValues.loadingEmpresas
                  : ''
              }
              options={this.props.empresas.allList.map((item) => {
                return {
                  label: getFormattedCNPJ(item.cnpjEmpresa) + ' - ' + item.nome,
                  value: item.id,
                };
              })}
              value={this.props.assessores.assessorEditing.idEmpresa || -1}
              onChange={(value) => {
                const currValue = value ? value.value : -1;
                this.setValue({
                  target: {
                    name: 'idEmpresa',
                    value: currValue,
                  },
                });
              }}
              loading={this.props.empresas.loadingAllList}
              loadingMessage={this.props.languageValues.loadingEmpresas}
              disabled={
                this.fieldDisabled() || this.props.empresas.loadingAllList
              }
            />
          </Col>
        </Row>
      </GenericModalCadastro>
    );
  }
}

AssessorEditModal.propTypes = {
  cpf: PropTypes.string,
  modalKey: PropTypes.string.isRequired,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  assessores: state.assessores,
  logradouro: state.logradouro,
  empresas: state.empresas,
  auth: state.auth,
  programas: state.assessores.programas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeAssessorEditingValue,
      loadAllCooperativas,
      clearAssessorEditing,
      closeModal,
      loadAssessorByCPF,
      saveAssessorByCPF,
      loadAllEmpresas,
      loadProgramasAtivos,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssessorEditModal);
